export default __webpack_public_path__ + "static/media/litho-demo-single-project-page-01.78c018e9.jpg";